import { Typography, Card, CardContent, Button } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import './styles.css';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
	let navigate = useNavigate();
	return (
		<div className="pageNotFoundContainer">
			<Card className="pageNotFoundCard" sx={{ borderRadius: '20px' }}>
					<div className="pageNotFoundIconContainer" >
						<ReportProblemIcon  sx={{ fontSize: 60 }} color="secondary"/>
					</div>
					<CardContent>
						<Typography gutterBottom variant="h5" component="div" className="pageNotFoundText">
							Oops! Page not found!
						</Typography>
						<div className="pageNotFoundSubTextContainer">
							<Typography variant="body2" color="text.secondary" className="pageNotFoundText">
								We cannot find the page you have requested. 
							</Typography>
							<Typography  variant="body2" color="text.secondary" className="pageNotFoundText">
								Please go to the Home Page or make another selection from the menu.
							</Typography>
						</div>
						<div className='pageNotFoundIconContainer'>
							<Button variant='contained' color='secondary' onClick={() => navigate('')}>Home</Button>
						</div>
					</CardContent>
			</Card>
		</div>
	)
}

export default PageNotFound;